import { render, staticRenderFns } from "./card.pug?vue&type=template&id=5f8713b3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./card.scss?vue&type=style&index=0&id=5f8713b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8713b3",
  null
  
)

export default component.exports